import { render, staticRenderFns } from "./kohota-flats.vue?vue&type=template&id=4c980662&"
import script from "./kohota-flats.vue?vue&type=script&lang=js&"
export * from "./kohota-flats.vue?vue&type=script&lang=js&"
import style0 from "./kohota-flats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports